// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  color: white;
  text-align: center;
  padding: 4rem 2rem;
}

.hero h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.hero p {
  font-size: 1.2rem;
  opacity: 0.9;
  margin-bottom: 2rem;
}

.hero-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn-primary {
  background: white;
  color: #2563eb;
  border: none;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.btn-primary:hover {
  background: #f0f0f0;
}

.btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
}

.home-container {
  padding: 2rem;
  max-width: 1100px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  margin: 2rem 0 1.5rem;
  font-size: 1.6rem;
  color: #1e3a5f;
}

.steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.step-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.step-number {
  width: 48px;
  height: 48px;
  background: #2563eb;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0 auto 1rem;
}

.step-card h3 {
  margin-bottom: 0.5rem;
  color: #111827;
}

.step-card p {
  color: #6b7280;
  line-height: 1.5;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
}

.category-card {
  background: white;
  padding: 1.5rem 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 2px solid transparent;
}

.category-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border-color: #2563eb;
}

.category-card h3 {
  margin: 0;
  font-size: 1rem;
  color: #1e3a5f;
}
`, "",{"version":3,"sources":["webpack://./src/Home.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB","sourcesContent":[".hero {\n  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);\n  color: white;\n  text-align: center;\n  padding: 4rem 2rem;\n}\n\n.hero h1 {\n  font-size: 2.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.hero p {\n  font-size: 1.2rem;\n  opacity: 0.9;\n  margin-bottom: 2rem;\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n}\n\n.btn-primary {\n  background: white;\n  color: #2563eb;\n  border: none;\n  padding: 0.8rem 2rem;\n  font-size: 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.btn-primary:hover {\n  background: #f0f0f0;\n}\n\n.btn-secondary {\n  background: transparent;\n  color: white;\n  border: 2px solid white;\n  padding: 0.8rem 2rem;\n  font-size: 1rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.home-container {\n  padding: 2rem;\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.section-title {\n  text-align: center;\n  margin: 2rem 0 1.5rem;\n  font-size: 1.6rem;\n  color: #1e3a5f;\n}\n\n.steps-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.step-card {\n  background: white;\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  text-align: center;\n}\n\n.step-number {\n  width: 48px;\n  height: 48px;\n  background: #2563eb;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  font-weight: 700;\n  margin: 0 auto 1rem;\n}\n\n.step-card h3 {\n  margin-bottom: 0.5rem;\n  color: #111827;\n}\n\n.step-card p {\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n.category-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 1rem;\n}\n\n.category-card {\n  background: white;\n  padding: 1.5rem 1rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  text-align: center;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  border: 2px solid transparent;\n}\n\n.category-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  border-color: #2563eb;\n}\n\n.category-card h3 {\n  margin: 0;\n  font-size: 1rem;\n  color: #1e3a5f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
